export default "__VITE_ASSET__217b7626__"